module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Recipe list","name":{"label":"Name"},"slogan":{"label":"Slogan"},"new":"New","error":{"load":"load failed."}},"ja":{"title":"レシピ一覧","name":{"label":"料理名"},"slogan":{"label":"キャッチコピー"},"new":"新規登録"}}')
  delete Component.options._Ctor
}
